import React, { useEffect, useRef, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import { ExpansionPanelSummary } from '../../../common/components/ExpansionPanelSummary';
import { extraPrice } from '../BookingPaymentForm/extraPrice';
import { getServiceTypeById } from '../../models/service-type';
import css from './BookingDetailsForm.module.css'
import { useDictionary } from '../../../common/contexts/DictionaryContext';

const Luggage = ({ transfer, updateTransfer }) => {
    const { t } = useTranslation();
    const { luggages = [] } = useDictionary();
    const firstRef = useRef(null);
    const [isExpanded, setExpanded] = useState(false);

    useEffect(() => {
        if (!isExpanded) {
            return;
        }

        // TODO check if it works
        const btn = firstRef.current.querySelector('[role="button"]');

        if (btn) {
            btn.focus();
        }
    }, [isExpanded]);

    const onLuggageClick = ({ name, value }) => {
        if (value || transfer.extras.onlyHandLuggage) {
            return;
        }
        updateTransfer({ name, value: 1 });
    };

    const excludedLuggageCodes = ['ADD', 'HL'];

    return (
        <Accordion onChange={(_, expanded) => setExpanded(expanded)}>
            <ExpansionPanelSummary text="booking.additionalLuggage" />
            <Box sx={{ p: 1 }}>
                <div className={css.grid} ref={firstRef}>
                    {luggages.map((luggage, luggageKey) => !excludedLuggageCodes.includes(luggage.internalCode) && (
                        <div key={luggageKey} className={css.gridCell}>
                            <Select
                                sx={{ width: '64px' }}
                                value={transfer.extras[luggage.internalCode] || 0}
                                name={`extras.${luggage.internalCode}`}
                                onChange={updateTransfer}
                                onMouseDown={() =>
                                    onLuggageClick({
                                        name: `extras.${luggage.internalCode}`,
                                        value: transfer.extras[luggage.internalCode],
                                    })
                                }
                            >
                                {[...Array(10)].map((_, key) => (
                                    <MenuItem value={key} key={key}>
                                        {key}
                                    </MenuItem>
                                ))}
                            </Select>
                            <Typography sx={{ ml: 1 }}>
                                {/*get the service type first, then get the price for this service type*/}
                                {t(`extras.${luggage.internalCode}`)}&nbsp;
                                {extraPrice(luggage[getServiceTypeById(transfer.serviceTypeId)])}
                            </Typography>
                        </div>
                    ))}
                </div>
            </Box>
        </Accordion>
    );
};

export { Luggage };
